export default __webpack_public_path__ + "static/media/IMG_5359.ebdab10a.WEBP";